

















import { Component, Prop } from "vue-property-decorator";
import OneOrThreeWeekAddV4 from "./OneOrThreeWeekAddV4.vue";
import { ReceiptVisitRecord } from "#/model/receipt";

interface MergedRvrPair {
  base: ReceiptVisitRecord;
  result: ReceiptVisitRecord;
}

@Component
export default class OneOrThreeWeekAddV5 extends OneOrThreeWeekAddV4 {
  @Prop({ default: () => [] })
  private readonly receiptVisitRecords!: ReceiptVisitRecord[];

  //長時間バリデーション（令和8年法改正対応）
  // 令和8年6月以降の基本療養費Ⅱ・精神科基本療養費Ⅲは、同日の訪問合算後の時間が
  // 91分以上であれば訪問時間が90分未満でも長時間加算を算定できる
  protected chackLongTimeFlgV5(): boolean | string {
    if (!this.long_time_flg || this.disableCheckLongTimeFlg()) {
      return true;
    }
    const start = new Date(
      this.event.visit_record.service_start_datetime.replace(/-/g, "/")
    );
    const end = new Date(
      this.event.visit_record.service_end_datetime.replace(/-/g, "/")
    );
    const diff = Math.abs((end.getTime() - start.getTime()) / (60 * 1000));
    if (diff < 91) {
      const visitDate = this.event.visit_record.service_start_datetime.slice(
        0,
        10
      );
      // 令和8年法改正以降の合算対象訪問（基本療養費Ⅱ・精神科基本療養費Ⅲ）は
      // 合算ペアを取得して合算後の時間で判定する
      if (
        this.isAfterR8Houkaisei(visitDate) &&
        this.isMergeTargetVisit(
          this.receiptVisitRecord.mental_div,
          this.receiptVisitRecord.remedy_div
        )
      ) {
        const sameDayTargets = this.getSameDayMergeTargetRvrs(visitDate);
        const pairs = this.getMergedPairs(sameDayTargets);
        if (this.isMergedOver90min(this.receiptVisitRecord, pairs)) {
          return true;
        }
      }
      return "訪問時間が長時間訪問看護に該当されません";
    }
    return true;
  }

  // 令和8年6月法改正（2026-06-01）以降かどうか
  private isAfterR8Houkaisei(date: string): boolean {
    return date >= "2026-06-01";
  }

  // 訪問合算の対象となる療養費かどうか
  // 基本療養費Ⅱ（mental_div=1, remedy_div=2）または
  // 精神科基本療養費Ⅲ（mental_div=2, remedy_div=3）が対象
  private isMergeTargetVisit(mentalDiv: number, remedyDiv: number): boolean {
    return (
      (mentalDiv === 1 && remedyDiv === 2) ||
      (mentalDiv === 2 && remedyDiv === 3)
    );
  }

  // 当日の合算対象訪問を receiptVisitRecords から抽出して返す
  // 編集中の receiptVisitRecord は最新値（props）を優先して差し替える
  private getSameDayMergeTargetRvrs(date: string): ReceiptVisitRecord[] {
    const result: ReceiptVisitRecord[] = [];
    let currentFound = false;
    for (const rvr of this.receiptVisitRecords) {
      if (rvr.cancel_flg !== 0) continue;
      if (!rvr.service_start_datetime || rvr.service_start_datetime.length < 10)
        continue;
      if (rvr.service_start_datetime.slice(0, 10) !== date) continue;
      if (!this.isMergeTargetVisit(rvr.mental_div, rvr.remedy_div)) continue;
      // 編集中レコードは props の値（最新）を使う
      if (
        rvr.visit_record_id === this.receiptVisitRecord.visit_record_id &&
        rvr.sub_no === this.receiptVisitRecord.sub_no
      ) {
        result.push(this.receiptVisitRecord);
        currentFound = true;
      } else {
        result.push(rvr);
      }
    }
    // 未保存の新規登録など receiptVisitRecords に存在しない場合は追加
    if (
      !currentFound &&
      this.isMergeTargetVisit(
        this.receiptVisitRecord.mental_div,
        this.receiptVisitRecord.remedy_div
      )
    ) {
      result.push(this.receiptVisitRecord);
    }
    return result;
  }

  // 訪問合算のペアを取得する
  // バックエンドの GetMergedRvrPairs と同じアルゴリズム:
  //   開始時刻順に並べ、20分以上30分未満の訪問を合算元として
  //   直前2時間以内かつ20分以上の訪問を合算先として対応づける
  private getMergedPairs(rvrs: ReceiptVisitRecord[]): MergedRvrPair[] {
    const diffMin = (a: string, b: string): number => {
      const ta = new Date(a.slice(0, 16).replace(/-/g, "/"));
      const tb = new Date(b.slice(0, 16).replace(/-/g, "/"));
      return (tb.getTime() - ta.getTime()) / 60000;
    };
    const sorted = [...rvrs].sort((a, b) =>
      a.service_start_datetime.localeCompare(b.service_start_datetime)
    );
    const pairs: MergedRvrPair[] = [];
    // 合算元インデックス → 合算先インデックスの対応表（合算先の連鎖追跡用）
    const resultToBaseIdx: Record<number, number> = {};
    for (let idx = 0; idx < sorted.length; idx++) {
      const rvr = sorted[idx];
      // 緊急訪問・先頭訪問は合算元にならない
      if (rvr.medical_urgent_flg === 1 || idx === 0) continue;
      const serviceTime = diffMin(
        rvr.service_start_datetime,
        rvr.service_end_datetime
      );
      // 20分未満または30分以上の訪問は合算対象外
      if (serviceTime < 20 || serviceTime >= 30) continue;
      for (let searchIdx = idx - 1; searchIdx >= 0; searchIdx--) {
        const candidate = sorted[searchIdx];
        // 緊急訪問は合算先になれない
        if (candidate.medical_urgent_flg === 1) continue;
        const gap = diffMin(
          candidate.service_end_datetime,
          rvr.service_start_datetime
        );
        // 直前訪問との間隔が2時間以上なら以降は探さない
        if (gap >= 120) break;
        const candidateTime = diffMin(
          candidate.service_start_datetime,
          candidate.service_end_datetime
        );
        // 20分未満の訪問は合算先になれない
        if (candidateTime < 20) continue;
        let baseIdx = searchIdx;
        // 候補が既に合算元の場合、その合算先を真の合算先として間隔を再確認
        if (baseIdx in resultToBaseIdx) {
          baseIdx = resultToBaseIdx[baseIdx];
          const baseGap = diffMin(
            sorted[baseIdx].service_end_datetime,
            rvr.service_start_datetime
          );
          if (baseGap >= 120) continue;
        }
        resultToBaseIdx[idx] = baseIdx;
        pairs.push({ base: sorted[baseIdx], result: rvr });
        break;
      }
    }
    return pairs;
  }

  // 対象訪問が合算先となるペアの合計時間が90分以上かどうか
  // visit_record_id + sub_no で対象訪問を特定し、合算元の時間を加算して判定する
  private isMergedOver90min(
    target: ReceiptVisitRecord,
    pairs: MergedRvrPair[]
  ): boolean {
    const diffMin = (a: string, b: string): number => {
      const ta = new Date(a.slice(0, 16).replace(/-/g, "/"));
      const tb = new Date(b.slice(0, 16).replace(/-/g, "/"));
      return (tb.getTime() - ta.getTime()) / 60000;
    };
    if (
      !target.service_start_datetime ||
      target.service_start_datetime.length < 16
    )
      return false;
    if (!target.service_end_datetime || target.service_end_datetime.length < 16)
      return false;
    // 対象訪問が合算先となっているペアを抽出
    const targetPairs = pairs.filter(
      p =>
        p.base.visit_record_id === target.visit_record_id &&
        p.base.sub_no === target.sub_no
    );
    // 合算ペアがなければ対象外
    if (targetPairs.length === 0) return false;
    // 合算先の時間 + 合算元の時間の合計を算出
    let total = diffMin(
      target.service_start_datetime,
      target.service_end_datetime
    );
    for (const pair of targetPairs) {
      if (
        !pair.result.service_start_datetime ||
        pair.result.service_start_datetime.length < 16
      )
        return false;
      if (
        !pair.result.service_end_datetime ||
        pair.result.service_end_datetime.length < 16
      )
        return false;
      total += diffMin(
        pair.result.service_start_datetime,
        pair.result.service_end_datetime
      );
    }
    return total >= 90;
  }

  //登録時に、disabledの項目は0にする
  public clearDisableItemV4() {
    // コロナ加算が無くなったタイミングよりあとは何もしない
    if (this.yearmonth >= "2024-04") {
      return;
    }
    //長時間（新型コロナウイルス臨時加算：緊急）
    if (
      this.disableCheckLongTimeFlg() &&
      this.long_time_flg_covid19_urgent_div &&
      !this.long_time_flg_covid19_plan_div
    ) {
      this.receiptVisitRecord.long_time_flg = 2;
    }
    //長時間（新型コロナウイルス臨時加算：計画）
    if (
      this.disableCheckLongTimeFlg() &&
      !this.long_time_flg_covid19_urgent_div &&
      this.long_time_flg_covid19_plan_div
    ) {
      this.receiptVisitRecord.long_time_flg = 4;
    }
    //長時間（全てチェック無し）
    if (
      this.disableCheckLongTimeFlg() &&
      !this.long_time_flg_covid19_urgent_div &&
      !this.long_time_flg_covid19_plan_div
    ) {
      this.receiptVisitRecord.long_time_flg = 0;
    }
  }
}
